/* Gameplan Preview — supplemental JS
   Video playback is handled by Minimog's built-in <video-component>.
   This file only handles Shopify editor re-init. */
(function () {
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-section-type="gameplan-preview"]');
    if (!section) return;
    // Re-init tabs-component if present
    var tabsEl = section.querySelector('tabs-component');
    if (tabsEl && tabsEl.tabs) {
      tabsEl.tabs.setActiveTab(0);
    }
  });
})();
